import { getAmpConfig } from 'shared/config/amp-config';

export const getKeycloakConfig = () => ({
  realm: 'Amplify',
  url: getAmpConfig().auth,
  clientId: 'learning-home',
});

export const keycloakInitConfig = {
  checkLoginIframe: true,
  onLoad: 'login-required' as const,
};

export const UPDATE_TOKEN_INTERVAL = 10000;
